import React, { useState, useEffect, type FC, createContext, useContext, ReactNode } from 'react';
interface ConsentContextType {
    hasConsented: boolean;
    consentChoiceMade: boolean;
    grantConsent: () => void;
    declineConsent: () => void;
    resetConsentChoice: () => void;
}

const ConsentContext = createContext<ConsentContextType | undefined>(undefined);

export const useConsent = () => {
    const context = useContext(ConsentContext);
    if (context === undefined) {
        throw new Error('useConsent must be used within a ConsentProvider');
    }
    return context;
};

export const ConsentProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [hasConsented, setHasConsented] = useState(false);
    const [consentChoiceMade, setConsentChoiceMade] = useState(true);

    useEffect(() => {
        const storedConsent = localStorage.getItem('user_consent');
        if (storedConsent === 'true') {
            setHasConsented(true);
            setConsentChoiceMade(true);
        } else if (storedConsent === 'false') {
            setHasConsented(false);
            setConsentChoiceMade(true);
        } else {
            setConsentChoiceMade(false);
        }
    }, []);

    const grantConsent = () => {
        localStorage.setItem('user_consent', 'true');
        setHasConsented(true);
        setConsentChoiceMade(true);
        window.location.reload()
    };

    const declineConsent = () => {
        localStorage.setItem('user_consent', 'false');
        setHasConsented(false);
        setConsentChoiceMade(true);
    };

    const resetConsentChoice = () => {
        localStorage.removeItem('user_consent');
        setHasConsented(false);
        setConsentChoiceMade(false);
        window.location.reload();
    };

    return (
        <ConsentContext.Provider value={{ hasConsented, consentChoiceMade, grantConsent, declineConsent, resetConsentChoice }}>
            {children}
        </ConsentContext.Provider>
    );
};